import { IButtonTheme } from '../../interface/button-theme.interface';

function getColoredButton(radius: number, name: string): IButtonTheme {
  return {
    borderRadius: radius,
    hasBackgroundColor: true,
    hasHoverBackgroundColor: true,
    colorBrightness: 0,
    hoverColorBrightness: -0.3,
    name
  };
}

function getUnColoredButton(radius: number, name: string): IButtonTheme {
  return {
    borderRadius: radius,
    hasBackgroundColor: false,
    hasHoverBackgroundColor: true,
    colorBrightness: 0,
    hoverColorBrightness: 0,
    name
  };
}

export const buttonThemes: IButtonTheme[] = [
  getUnColoredButton(100, 'Rounded corners, borders only'),
  getColoredButton(100, 'Rounded corners, filled'),
  getUnColoredButton(5, 'Slightly rounded corners, borders only'),
  getColoredButton(5, 'Slightly rounded corners, filled'),
  getUnColoredButton(0, 'Rectangle, borders only'),
  getColoredButton(0, 'Rectangle, filled')
];